import axios from "axios";

export default {
    state: {
        propertyTypes: [],
        filter: {}
    },
    getters: {
        PROPERTY_TYPES: state => {
            return state.propertyTypes;
        },
        PROPERTY_TYPES_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_PROPERTY_TYPES: (state, payload) => {
            state.propertyTypes = payload;
        },
    },
    actions: {
        GET_PROPERTY_TYPES: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`propertyTypes`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_PROPERTY_TYPES", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}